// Plan awareness hook — reads the current user's first org plan from the
// auth store (populated by /auth/me). For single-org users (the common case)
// this is all we need; multi-org UIs should pass the org id explicitly.

import { useAuthStore } from "@/stores/authStore";

export interface PlanInfo {
  slug: string;
  name: string;
  features: Record<string, boolean>;
  hasFeature: (feature: string) => boolean;
}

/**
 * Returns plan info for the primary (first) organization of the current user.
 * Falls back to a "free" plan with no features if anything is missing.
 */
export function usePlan(): PlanInfo {
  const user = useAuthStore((s) => s.user);
  const primary = user?.organizations?.[0];

  const slug = primary?.plan_slug ?? "free";
  const name = primary?.plan_name ?? "Free";
  const features = primary?.plan_features ?? {};

  return {
    slug,
    name,
    features,
    hasFeature: (feature: string) => Boolean(features[feature]),
  };
}
